import { render } from "./SendBalance.vue?vue&type=template&id=168fb454&scoped=true"
import script from "./SendBalance.vue?vue&type=script&lang=js"
export * from "./SendBalance.vue?vue&type=script&lang=js"

import "./SendBalance.vue?vue&type=style&index=0&id=168fb454&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-168fb454"

export default script